export default __webpack_public_path__ + "static/media/store-applications-page-icon.7c571d9f.svg";